<script setup>
    defineProps(['src']);
    const publicPath = process.env.VUE_APP_BASE_URL  || '/';
</script>

<template>
    <img :src="`${publicPath}images/${src}`">
</template>